import React from "react";
import { Grid, Paper, Typography, Chip } from "@mui/material";

const ShiftInformation = ({ shift }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Shift Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="caption"
            color="textSecondary"
            display="block"
            gutterBottom
          >
            Shift Type
          </Typography>
          <Chip
            label={shift}
            size="small"
            sx={{
              ...(shift === "AM"
                ? { bgcolor: "#fff3e0", color: "#ef6c00" }
                : shift === "PM"
                ? { bgcolor: "#f3e5f5", color: "#7b1fa2" }
                : { bgcolor: "#e8f5e8", color: "#2e7d32" }),
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ShiftInformation;
